"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchSearchResultItemHeader = void 0;
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const MatchSearchResultItemHeader = () => (react_1.default.createElement("div", { className: 'suggested-match-item suggested-match-item-header' },
    react_1.default.createElement("div", { className: 'submission-date' }, "Submission Date"),
    react_1.default.createElement("div", { className: 'recording-groups-count' },
        "Recording Groups",
        react_1.default.createElement(CustomToolTip_1.default, { type: '?', inverse: true, info: react_1.default.createElement(react_1.default.Fragment, null, "This column shows the number of recording groups for each submitted match suggestion. Recordings are grouped together based on similar data, and may be from multiple digital service providers (DSPs).") })),
    react_1.default.createElement("div", { className: 'work-title' }, "Work Title"),
    react_1.default.createElement("div", { className: 'song-code' }, "MLC Song Code"),
    react_1.default.createElement("div", { className: 'writers' }, "Writers"),
    react_1.default.createElement("div", { className: 'status-component' }, "Status")));
exports.MatchSearchResultItemHeader = MatchSearchResultItemHeader;
